// BLOQUEIO-DE-PEDIDOS-DELIVERY-NO-SMARTMENU.spec.md: o cliente só monta pedido quando a loja está aberta, o link não é só de
// visualização e a empresa não desligou o recebimento de pedidos de delivery (orders_blocked, calculado pela API só para o link de delivery).
export function canPlaceOrders(companyData) {
    return Boolean(companyData?.status) && companyData?.type !== 'view' && !companyData?.orders_blocked;
}

export const ORDERS_BLOCKED_MESSAGE = 'Esta loja não está recebendo pedidos de delivery pelo cardápio no momento.';
